import React from "react";

const RootLayout = ({ children }) => children; // just for proxying loading screen

export default React.memo(RootLayout);
